import { KeycloakUser } from "./Auth";

export enum HTTP_METHOD {
  PUT = "put",
  POST = "post",
  GET = "get",
  DELETE = "delete",
}

export type UserRequest = {
  username?: KeycloakUser.username | null;
  groupID?: number | null | string;
  range?: string;
  sortBy?: string;
  sortDirection?: string;
  criterias?: Criteria[];
  CriteriaList?: any;
  ShowCompleted?: boolean;
};

// "criterias": [{"field": "msag_id", "type": "=", "value": "952904"}]

export type Criteria = {
  field?: string;
  type?: string;
  value?: string | number;
  val_array?: string[];
  operator?: string;
};

export type Response<T> = {
  response: any;
  response_code: number;
  message: T;
};
